module.exports = __webpack_public_path__ + "static/img/8.f6300fb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fafafa/8.png
// module id = lbAq
// module chunks = 0